export default __webpack_public_path__ + "13eb515b50f151111ba79d2aee0ed9c8.png";